import React, { useEffect } from 'react';
import styles from './FirstLoginWizard.module.scss';
import WizardWrapper from '../../Wizard/Components/WizardWrapper';

interface Props {
	userId: string;
}

const FirstLoginWizard: React.FC<Props> = () => {
	useEffect(() => {
		document.body.classList.add('firstLoginWizard');

		return () => {
			document.body.classList.remove('firstLoginWizard');
		};
	}, []);

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<WizardWrapper wizardKey='first-login-patient-v2' />
			</div>
		</div>
	);
};

export default FirstLoginWizard;
